import React, { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Button, FileButton, Modal } from "@mantine/core";
import { IconFileUpload } from "@tabler/icons-react";

import { notifyUserFacingError } from "@util/toErrorMessage";

export default function AssetUpload({
  reqData = {},
  onSuccess = () => true,
  library = false,
}) {
  const [show, setShow] = useState(true);
  const [open, setOpen] = useState(false);
  const [uploadProps, setUploadProps] = useState({
    text: "",
    variety: null,
    color: "",
  });

  useEffect(() => {
    if (!open)
      setUploadProps({
        text: "",
        variety: null,
        color: "",
      });
  }, [open]);

  function onUpload(file, variety = null) {
    if (!file) return;

    const formData = new FormData();
    formData.append("tempfile", file);
    if (variety && library) {
      formData.append("library_variety", variety);
    }
    Object.keys(reqData || {}).forEach((k) => formData.append(k, reqData[k]));

    axios
      .post(`/${library ? "library-" : ""}assets/`, formData)
      .then(({ data }) => {
        const asset = data?.response?.[0];
        if (!asset?.id) {
          throw new Error("Upload succeeded but no asset was returned");
        }

        toast.success("Uploaded!");
        setShow(false);
        setOpen(false);
        setUploadProps({
          text: "",
          variety: null,
          color: "",
        });
        onSuccess(asset);

        setTimeout(() => {
          setShow(true);
        }, 1);
      })
      .catch((err) => {
        notifyUserFacingError(err, toast, { source: "asset_upload" });
      });
  }

  if (library) {
    if (!show) return null;

    return (
      <React.Fragment>
        <Button
          size="xs"
          color="teal"
          variant="subtle"
          onClick={() => setOpen(true)}
          leftSection={<IconFileUpload />}
        >
          Upload Asset
        </Button>
        <Modal
          title="New library asset"
          size="xl"
          opened={open}
          onClose={() => setOpen(false)}
        >
          <FileButton
            mt="md"
            onChange={(e) => onUpload(e, uploadProps.variety)}
          >
            {(props) => (
              <Button
                {...props}
                variant="light"
                color={uploadProps.color ? uploadProps.color : "green"}
                size="xs"
                leftSection={
                  uploadProps.icon ? uploadProps.icon : <IconFileUpload />
                }
                disabled={uploadProps.variety === null}
              >
                {`Upload ${uploadProps.text} Asset`}
              </Button>
            )}
          </FileButton>
        </Modal>
      </React.Fragment>
    );
  }

  return (
    <FileButton onChange={(e) => onUpload(e)}>
      {(props) => (
        <Button
          {...props}
          variant="light"
          color="green"
          leftSection={<IconFileUpload />}
          size="xs"
        >
          Upload
        </Button>
      )}
    </FileButton>
  );
}
